module.exports = __webpack_public_path__ + "img/pin_d_black.6090b51f.svg";